import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ArrowIcon from '../pngs/scroll-to-top.png'; // Update this path to your arrow PNG

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <motion.button
      onClick={scrollToTop}
      initial={{ opacity: 0 }}
      animate={{ opacity: isVisible ? 1 : 0 }}
      transition={{ duration: 0.3 }}
      style={{
        position: 'fixed',
        bottom: '50px',
        right: '50px',
        backgroundColor: '#333',
        color: 'white',
        border: 'none',
        borderRadius: '50%',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
        zIndex: 1000,
        display: isVisible ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0',
      }}
      whileHover={{ 
        backgroundColor: '#555',
        y: -3,
        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.4)'
      }}
      whileTap={{ y: -1 }}
      aria-label="Scroll to top"
      title="Go to top"
    >
      <img 
        src={ArrowIcon} 
        alt="Scroll to top" 
        style={{
          width: '44px',
          height: '44px',
          objectFit: 'contain',
        }}
      />
    </motion.button>
  );
};

export default ScrollToTop;